export default __webpack_public_path__ + "static/media/gold-5.bf561419.png";